export const onPromiseTimeout = (promise, functionOnTimeout, timeout) => {
  let cancellablePromiseId = null
  const cancellablePromise = new Promise((resolve, reject) => {
    cancellablePromiseId = setTimeout(() => {
      try {
        resolve(functionOnTimeout())
      } catch (error) {
        reject(error)
      }
    }, timeout)
  })

  return Promise.race([promise, cancellablePromise]).finally(() =>
    clearTimeout(cancellablePromiseId)
  )
}
